<template lang="pug">
    v-dialog(v-model="dialog" persistent max-width="400")
        v-card(class="menu")
            v-toolbar(flat justify-end text-right)
                v-spacer
                v-toolbar-title(class="font-weight-bold title-text primary--text mr-6") ALASAN PEMBATALAN
            v-card-text
                v-form(ref="formReason" id="formReason" @submit.prevent="doReason" lazy-validation)
                    v-layout(wrap class="mx-6")
                        v-flex(lg12 md12 xs12)
                            v-text-field(dense v-model="reason" label="Alasan Pembatalan" :rules="[v => !!v || 'Input alasan pembatalan']" required)
            v-card-actions(class="justify-center menu-btn")
                v-btn(class="mb-3" @click="cancel") Kembali
                    v-icon(small) mdi-arrow-left-circle
                v-btn(class="mb-3" color="btnprimary white--text" type="submit" form="formReason") Lanjut
                    v-icon(small) mdi-arrow-right-circle
</template>
<script>
export default {
    name: "FDialogReason",
    props: ["value"],
    data() {
        return {
            dialog: false,
            reason: ""
        }
    },
    watch: { 
        value(val) {
            this.doInitModel(val);
        }
    },
    mounted() {
        this.doInitModel(this.value);
    },
    methods: {
        doInitModel(values) {
            this.dialog = values ? values : false;
            if (this.$refs.formReason) {
                this.$refs.formReason.resetValidation();
            }
            this.reason = "";
        },
        doReason(){
            if (this.$refs.formReason.validate()) {
                this.$emit("reason", this.reason);
                this.$emit("dialog", false);
            }
        },
        cancel() {
            this.$emit("dialog", false);
        }
    },
}
</script>